import React, { useState } from "react";

import { Navbar, Container, Image, NavDropdown, Nav } from "react-bootstrap";
import { useUserActions } from "../hooks/user.actions";
import { Link } from "react-router-dom";
import { Context } from "./Layout";
import { useContext } from "react";
import i18n from '../i18n';

function Navigationbar() {
    const userActions = useUserActions();
    const user = userActions.getUser();
    const { setToaster } = useContext(Context);
    const [, setLanguage] = useState(i18n.language);

    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        setLanguage(lang);
    };

    const handleLogout = () => {
        userActions.logout().catch((e) => {
            console.log(e);
            setToaster({
                type: "danger",
                message: "Logout failed",
                show: true,
                title: e.data?.detail | "An error occurred.",
            });
        }
        );
    };

    return (
        <Navbar bg="primary" variant="dark">
            <Container>
                <Navbar.Brand className="fw-bold" href="#home">
                    Postagram
                </Navbar.Brand>
                <Navbar.Collapse className="justify-content-end">
                    <Nav>
                        <NavDropdown title="Language" id="language-dropdown">
                            <NavDropdown.Item onClick={() => handleLanguageChange('en')}>English</NavDropdown.Item>
                            <NavDropdown.Item onClick={() => handleLanguageChange('es')}>Español</NavDropdown.Item>
                        </NavDropdown>
                        <NavDropdown
                            title={
                                <Image
                                    src={user.avatar}
                                    roundedCircle
                                    width={36}
                                    height={36}
                                />
                            }
                        >
                            <NavDropdown.Item as={Link} to={`/profile/${user.id}/`}>Profile</NavDropdown.Item>
                            <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigationbar;